import { OpenCaseFxDTO, ShopItemType } from './types'
import { http } from '@/shared/http.ts'

export const getCases = async (token: string) => {
  // TODO: clarify this type
  return await http.get<any>('/lb/', {
    token,
  })
}

export const getCaseContent = async (token: string, id: number) => {
  // TODO: clarify this type
  return await http.get<any>('/lb/contents', {
    token,
    queryParams: {
      lootbox_id: id,
    }
  })
}

export const postPurchaseKey = async (token: string, key_id: number) => {
  return await http.post<{ redirect_url: string, invoice_url: string }>(
    '/payment/purchase-key',
    {
      token,
      body: {
        key_id,
      },
    },
  )
}

export const getUniqueContent = async (token: string, id: number) => {
  // TODO: clarify this type
  return await http.get<any>('/lb/unique-content-status', {
    token,
    queryParams: {
      lootbox_id: id,
    }
  })
}

type LbClaimKeyResponse = {
  keys: number,
  free_keys: number,
  ok: boolean,
}
export const postClaimDailyKey = async (token: string) => {
  return await http.post<LbClaimKeyResponse>(
    '/lb/claim-key',
    { token }
  )
}

export const postOpenCase = async ({token, id: lootbox_id, currency}: OpenCaseFxDTO) => {
  // TODO: clarify this type
  return await http.post<any>(
    '/lb/open',
    {
      token,
      body: {
        lootbox_id,
        currency,
      }
    },
  )
}

export const getKeysBundles = async (token: string): Promise<ShopItemType[]> => {
  return await http.get<ShopItemType[]>('/lb/keys-bundles', {
    token,
  })
}
